export default "__VITE_ASSET__CWWOw4j0__"